import React from "react";

function Page4() {
  return (
    <div id="page4" className="page">
      <div className="description">
        <div className="inner">
          <div className="texts">
            <div className="background" />
            <h3>
              Transforming disparate data into actionable intelligence, Zignal Labs equips organizations with the information they need to protect their people, places, and position.
            </h3>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Page4;
